<template>
  <div id="cobrowse-client-p">
    <CobrowseClient/>
  </div>
</template>

<script>
//import ctilcobrowseConfiguration from './assets/plugin/ctilcobrowse.configuration.js';
//import ctilcobrowse from './assets/plugin/ctilcobrowse.js';
//import ctilshape from './assets/plugin/ctilshape.js';
import CobrowseClient from './components/CobrowseClient.vue'

export default {
  name: 'cobrowseviewer',
  components: {
    CobrowseClient
  },
  data(){ 
    return{
    }
  },
  created(){
    //window.ctilcobrowseConfiguration = ctilcobrowseConfiguration;
    //console.log(ctilcobrowseConfiguration)
    //console.log(ctilcobrowseConfiguration.colors)
    //window.ctilcobrowse = ctilcobrowse;
    //window.ctilshape = ctilshape;
  }
}
</script>

<style>
/* roboto-regular - latin */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  src: url('./fonts/roboto-v20-latin-regular.eot'); /* IE9 Compat Modes */
  src: local('Roboto'), local('Roboto-Regular'),
       url('./fonts/roboto-v20-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('./fonts/roboto-v20-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('./fonts/roboto-v20-latin-regular.woff') format('woff'), /* Modern Browsers */
       url('./fonts/roboto-v20-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
       url('./fonts/roboto-v20-latin-regular.svg#Roboto') format('svg'); /* Legacy iOS */
}
/* roboto-500 - latin */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  src: url('./fonts/roboto-v20-latin-500.eot'); /* IE9 Compat Modes */
  src: local('Roboto Medium'), local('Roboto-Medium'),
       url('./fonts/roboto-v20-latin-500.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('./fonts/roboto-v20-latin-500.woff2') format('woff2'), /* Super Modern Browsers */
       url('./fonts/roboto-v20-latin-500.woff') format('woff'), /* Modern Browsers */
       url('./fonts/roboto-v20-latin-500.ttf') format('truetype'), /* Safari, Android, iOS */
       url('./fonts/roboto-v20-latin-500.svg#Roboto') format('svg'); /* Legacy iOS */
}
/* roboto-700 - latin */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  src: url('./fonts/roboto-v20-latin-700.eot'); /* IE9 Compat Modes */
  src: local('Roboto Bold'), local('Roboto-Bold'),
       url('./fonts/roboto-v20-latin-700.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('./fonts/roboto-v20-latin-700.woff2') format('woff2'), /* Super Modern Browsers */
       url('./fonts/roboto-v20-latin-700.woff') format('woff'), /* Modern Browsers */
       url('./fonts/roboto-v20-latin-700.ttf') format('truetype'), /* Safari, Android, iOS */
       url('./fonts/roboto-v20-latin-700.svg#Roboto') format('svg'); /* Legacy iOS */
}

#cobrowse-client-p {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: Roboto;
}

#cobrowse-client-p{
  position: fixed;
  top:0;
  left:0;
  width: 100%;
  height: 100px;
  background: #E3E3E3;
  z-index:500;
}
</style>
